
import React from 'react';

const BasketUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='49'
			height='48'
			fill='none'
			viewBox='0 0 49 48'
		>
			<path
				fill='#2d2d2d'
				d='M39.5 12.675h-5.07L28.835 1.5 26.15 2.835l4.92 9.825H17.93l4.92-9.825L20.165 1.5 14.57 12.675H9.5c-1.65 0-3 1.35-3 3v4.5c0 .825.675 1.5 1.5 1.5h.63L10.76 35.4c.12.735.75 1.275 1.485 1.275H36.74c.735 0 1.365-.54 1.485-1.275l2.13-13.725H41c.825 0 1.5-.675 1.5-1.5v-4.5a3 3 0 00-3-3zm-30 3h30v3H9.5v-3zm25.965 18h-21.93l-1.86-12H37.34l-1.875 12z'
			></path>
			<path
				fill='#2d2d2d'
				d='M32 23.176h-3v9h3v-9zM26 23.176h-3v9h3v-9zM20 23.176h-3v9h3v-9zM36.5 42.676h-24v3h24v-3z'
			></path>
		</svg>
	);
};

export default BasketUnderline;
